enum StudioState {
    ONLINE = 'ONLINE',
    OFFLINE = 'OFFLINE',
    UNINITIALIZED = 'UNINITIALIZED',
}

export default StudioState;
